const LABS_SESSION_KEY = 'vaiu-labs-enabled';

export function persistLabsEnabled(): void {
  try {
    sessionStorage.setItem(LABS_SESSION_KEY, '1');
  } catch {
    /* quota / private mode */
  }
}

export function clearLabsEnabled(): void {
  try {
    sessionStorage.removeItem(LABS_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function isLabsEnabledThisSession(): boolean {
  try {
    return sessionStorage.getItem(LABS_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

/** True after `?labs=on` in this tab, until `?labs=off` or the tab is closed. */
export function isLabsUnlocked(search: string): boolean {
  const params = new URLSearchParams(search);
  const flag = params.get('labs');
  if (flag === 'off') return false;
  if (flag === 'on') return true;
  return isLabsEnabledThisSession();
}
